const baseURL = `${import.meta.env.VITE_API_URL}/api`;

export const apiDomainUrl = import.meta.env.VITE_API_URL;

export const VERSION = import.meta.env.VITE_VERSION;

export default baseURL;
